import { PropTypes } from 'prop-types';

import { formatImageInfoCardListData } from '@/utils/homepageUtils';
import Card3 from '@/components/layout/espots/Card3';
import Card4 from '@/components/layout/espots/Card4';

import styles from './DuoCardList.module.scss';
import { ESPOT_CARD_TYPE } from '@/constants/espot';

const DuoCardList = ({ data }) => (
  <div className={styles.container}>
    {data?.espotsList?.map((item) => {
      switch (item.espot.cardType) {
        case ESPOT_CARD_TYPE.CARD_3:
          return <Card3 key={item._id} data={formatImageInfoCardListData(item.espot)} />;
        case ESPOT_CARD_TYPE.CARD_4:
          return <Card4 key={item._id} data={formatImageInfoCardListData(item.espot)} />;
      }
    })}
  </div>
);

DuoCardList.propTypes = {
  data: PropTypes.shape({
    espotsList: PropTypes.array
  })
};

export default DuoCardList;
